import { createElement, FC, Fragment, useContext, useState } from 'react';

import Header from '../component/compound/Header';
import TransitionToKaizenIdModal from '../component/compound/TransitionToKaizenIdModal';
import { context as ConfigContext } from '../context/config';
import { context as StateContext } from '../context/state';
import { SideBarProps } from './Toolbar';

type Props = {
  isOpenedByIframe: boolean;
  sideBarProps: SideBarProps;
};

export const ToolBarForSP: FC<Props> = ({ sideBarProps, isOpenedByIframe }) => {
  const config = useContext(ConfigContext);
  const state = useContext(StateContext);
  // 新規プロジェクト作成時のRegion別処理を実行
  const [isModalOpen, setModal] = useState(false);

  return !state.fatalError && state.authentication.fetching === 0 && state.authentication.signedInUser ? (
    <>
      <Header {...sideBarProps} isOpenedByIframe={isOpenedByIframe} />
      <TransitionToKaizenIdModal
        urlToId={config.ID_WEB_URL}
        open={isModalOpen}
        language={state.language}
        onRequestClose={() => setModal(false)}
      />
    </>
  ) : (
    <div />
  );
};
